<div
  class="chip"
  (click)="onChipSelect()"
  [ngClass]="{ 'chip--active': active && clickable, 'chip--clickable': clickable }">
  {{ text }}
</div>
